(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-draws/assets/jotai/atoms.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-draws/assets/jotai/atoms.js');
"use strict";

var _svs$lyckoplatsen$sha, _svs$lyckoplatsen$sha2, _svs$lyckoplatsen$sha3, _svs$lyckoplatsen$sha4, _svs$lyckoplatsen$sha5;

const _jotai = jotai,
  atom = _jotai.atom;
const primaryDraw = (_svs$lyckoplatsen$sha = svs.lyckoplatsen.shared_draws) === null || _svs$lyckoplatsen$sha === void 0 ? void 0 : _svs$lyckoplatsen$sha.data.primaryDraw;
const secondaryDraw = (_svs$lyckoplatsen$sha2 = svs.lyckoplatsen.shared_draws) === null || _svs$lyckoplatsen$sha2 === void 0 ? void 0 : _svs$lyckoplatsen$sha2.data.secondaryDraw;
const firstDraw = (_svs$lyckoplatsen$sha3 = svs.lyckoplatsen.shared_draws) === null || _svs$lyckoplatsen$sha3 === void 0 ? void 0 : _svs$lyckoplatsen$sha3.data.firstDraw;
const lastDraw = (_svs$lyckoplatsen$sha4 = svs.lyckoplatsen.shared_draws) === null || _svs$lyckoplatsen$sha4 === void 0 ? void 0 : _svs$lyckoplatsen$sha4.data.lastDraw;
const sortedDraws = (_svs$lyckoplatsen$sha5 = svs.lyckoplatsen.shared_draws) === null || _svs$lyckoplatsen$sha5 === void 0 ? void 0 : _svs$lyckoplatsen$sha5.data.sortedDraws;
const atoms = {
  primaryDrawAtom: atom(() => primaryDraw.draws),
  secondaryDrawAtom: atom(() => secondaryDraw.draws),
  sortedDrawsAtom: atom(() => sortedDraws),
  firstDrawAtom: atom(() => firstDraw),
  lastDrawAtom: atom(() => lastDraw)
};
Object.assign(svs.lyckoplatsen.components.shared_draws.jotai, {
  atoms
});

 })(window);